import Login from "./login";
import _request from "actions/_request";
import { Box, Button, Typography } from "@mui/material";

export default class ResetPassword extends Login {
    constructor(props) {
        super(props);

        this.titles = {
            rightTitle: "login",
            mainTitle: "forgotPass",
            smallTitle: "forgotSmall",
        };

        this.state = {
            ...this.state,
            newPassword: "",
            confirmPassword: "",
            resetError: null,
        };
    }

    async mainButtonClick() {
        const { email, newPassword, confirmPassword } = this.state;
        const url = window.location.href;
        const token = url.split('/').pop();

        if (!this.validateEmail(email)) {
            this.setState({ resetError: "Invalid email address" });
            return false;
        }

        if (newPassword !== confirmPassword) {
            this.setState({ resetError: "Passwords do not match" });
            return false;
        }

        if (!newPassword || !confirmPassword) {
            this.setState({ resetError: "Password fields cannot be empty" });
            return false;
        }

        const resp = await _request.auth.loading(async () => {
            return await _request.auth.resetPassword({
                email,
                password: newPassword,
                confirmPassword,
                token
            }, token);
        });

        if (resp?.isOk) {
            this.loginOk();
        } else {
            this.setState({ resetError: resp?.message || "Error resetting password" });
        }
    }


    renderForm() {
        const { resetError } = this.state;

        return (
            <Box className="flex column gap24">
                <Box className="flex column gap-6">
                    {this.insertEmail("email", "", "emailAddress", false)}
                    {this.insertPassword("newPassword", "", "password")}
                    {this.insertPassword("confirmPassword", "", "confirm")}
                </Box>
                {resetError && <Typography color="error">{resetError}</Typography>}

                <Box>
                    <Button
                        className="buttonNew"
                        onClick={this.mainButtonClick.bind(this)}
                    >
                        {this.tr("send")}
                    </Button>
                </Box>
            </Box>
        );
    }
}